<!--========== 教学分析评估报告管理 ==========-->
<template>
    <div class="app-container">
        <el-scrollbar shadow="never" class="stat-scrollbar">
            <div class="top-title">教学分析管理</div>
            <el-row :gutter="20" style="width: 100%">
                <el-col :span="6">
                    <el-card class="first-item" :body-style="{ padding: '10px' }">
                        <div class="stat-title">平台总剩余次数</div>
                        <div class="stat-count">
                            <span class="stat-count-span">{{sgInfo.residuenum}}</span>次
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card  :body-style="{ padding: '10px' }">
                        <div class="stat-title">已分配总次数</div>
                        <div class="stat-count1">
                            <span class="stat-count-span">{{ptInfo.totalCount}}</span>次
                        </div>
                        <div class="stat-count2">
                            (正式:{{ptInfo.zsTotalCount}}次,试用:{{ptInfo.syTotalCount}}次)
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card :body-style="{ padding: '10px' }">
                        <div class="stat-title">已分配待使用总次数</div>
                        <div class="stat-count">
                            <span class="stat-count-span">{{ptInfo.totalCount-ptInfo.usedCount}}</span>次
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card :body-style="{ padding: '10px' }">
                        <div class="stat-title">消耗总次数</div>
                        <div class="stat-count">
                            <span class="stat-count-span">{{ptInfo.usedCount}}</span>次
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="40px">
                    <el-row class="mt10">
                        <el-col :span="6" class="mr10 mb0">
                            <el-form-item label="状态">
                                <el-select clearable @change="getPageList()" v-model="queryParams.status" placeholder="请选择">
                                    <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mr10 mb0">
                            <el-form-item label="类型">
                                <el-select clearable @change="getPageList()" v-model="queryParams.resourceType" placeholder="请选择">
                                    <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mr10 mb0">
                            <el-form-item >
                                <el-input v-model="queryParams.orgName" placeholder="请输入单位名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="handleQuery" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="2" class="mr0 mb0">

                        </el-col>
                        <el-col :span="3">
                            <el-button style="background-color: #3b62f8;color: #fff;" @click="handleOpen">+开通新组织</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 380px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="220px" align="center" label="单位名称" prop="orgName">
                    </el-table-column>
                    <el-table-column width="80px" align="center" label="类型" prop="status">
                        <template #default="scope">
                            <div class="s-sy" v-if="scope.row.resourceType===0">试用</div>
                            <div class="s-zs" v-if="scope.row.resourceType===1">正式</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200px" align="center" label="管理员" prop="orgAdminName">
                    </el-table-column>
                    <el-table-column width="100px" align="center" label="剩余次数" prop="leaveCount">
                        <template #default="scope">
                            <div>{{ scope.row.totalCount - scope.row.usedCount }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="80px" align="center" label="状态" prop="status">
                        <template #default="scope">
                            <div class="s-zc" v-if="scope.row.status===1">正常</div>
                            <div class="s-yj" v-if="scope.row.status===2">预警</div>
                            <div class="s-yw" v-if="scope.row.status===3">用完</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="160px" align="center" label="最后充值时间" prop="time">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.lastTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="160" label="操作" align="center">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="handleRecharge(scope.row)">充值</el-button>
                            <el-button type="primary" size="small" @click="handleDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]"  :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getPageList" />
            </div>
        </el-scrollbar>
    </div>

    <el-dialog class="ar-dialog" title="开通教学分析" v-model="isOrgAnalyseShow" width="540px">
        <el-form ref="analyseForm" :model="analyseForm" :rules="analyseFormRules" :label-width="100" label-position="top">
            <el-row>
                <el-col>
                    <el-form-item class="ar-form" label="开通单位" prop="orgId" >
                        <el-select filterable style="width: 80%;" v-model="analyseForm.orgId"
                                   placeholder="请选择开通单位">
                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                       :value="item.orgId" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item class="ar-form" label="充值类型" prop="resourceType" >
                        <el-radio-group v-model="analyseForm.resourceType">
                            <el-radio border label="试   用" :value="Number(0)" />
                            <el-radio border label="正   式" :value="Number(1)"  />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item class="ar-form" label="充值额度" prop="totalCount" >
                        <el-input-number v-model="analyseForm.totalCount" min="1"  />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitAnalyseForm">确 定</el-button>
                <el-button @click="isOrgAnalyseShow=!isOrgAnalyseShow">取 消</el-button>
            </div>
        </template>
    </el-dialog>


    <el-dialog class="ar-dialog" title="额度充值" v-model="isOrgRechargeShow" width="540px">
        <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeFormRules" :label-width="100"
                 label-position="top">
            <el-row>
                <el-col>
                    <el-form-item class="ar-form" label="充值单位" prop="orgName" >
                        <el-input v-model="rechargeForm.orgName" disabled style="width: 80%;"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="rechargeType===0">
                <el-col>
                    <el-form-item class="ar-form" label="充值类型" prop="resourceType" >
                        <el-radio-group v-model="rechargeForm.resourceType">
                            <el-radio  border label="试   用" :value="Number(0)" />
                            <el-radio border label="正   式" :value="Number(1)"  />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="rechargeType===1">
                <el-col>
                    <el-form-item class="ar-form" label="充值类型" prop="resourceType" >
                        <el-radio-group v-model="rechargeForm.resourceType">
                            <el-radio border label="正   式" :value="Number(1)"  />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item class="ar-form" label="充值额度" prop="rechargeCount" >
                        <el-input-number v-model="rechargeForm.rechargeCount" min="1"  />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitRechargeForm">确 定</el-button>
                <el-button @click="isOrgRechargeShow=!isOrgRechargeShow">取 消</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {resourceInfo,createAnalyseOrg,pageAnalyseOrg,ptInfo,rechargeResource} from "@/api/admin/analyseResource"
import {listOrg} from "@/api/admin/system"

export default {
    name: "index",
    components: {},
    data() {
        return {
            timestampToTime,
            isOrgAnalyseShow:false,
            isOrgRechargeShow:false,
            loading: true,// 遮罩层
            total: 0,// 总条数
            dataList: [],// 基础：基数数据表格数据
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                orgName:"",
                status:"",
                resourceType:"",
            },
            statusList: [
                { name: '正常', value: 1 },  //
                { name: '预警', value: 2 },  // 10<=以下预警
                { name: '用完', value: 3 },  //  剩余 0
            ],
            typeList: [
                { name: '试用', value: 0 },
                { name: '正式', value: 1 },
            ],
            sgInfo:{}, //额度信息
            ptInfo:{}, // 平台分配信息
            analyseForm:{
                orgId:'',
                resourceType:0,
                totalCount:1,
            },
            // 表单校验
            analyseFormRules: {
                orgId: [{ required: true, message: "请选择开通单位", trigger: "change" },],
                resourceType: [{ required: true, message: "请选择充值类型", trigger: "change" },],
                totalCount: [{ required: true, message: "请输入充值额度", trigger: "blur" },],
            },
            orgList:[],
            rechargeType:0,
            rechargeForm:{
                orgId:'',
                orgName:'',
                resourceType:0,
                rechargeCount:1,
            },
            rechargeFormRules: {
                orgName: [{ required: true, message: "请选择开通单位", trigger: "change" },],
                resourceType: [{ required: true, message: "请选择充值类型", trigger: "change" },],
                rechargeCount: [{ required: true, message: "请输入充值额度", trigger: "blur" },],
            },
        };
    },
    created() {
        this.getResourceInfo()
        this.getPtInfo()
        this.getOrgList()
        this.getPageList()

    },
    activated() {},
    watch: {},
    methods: {
        getResourceInfo(){
            resourceInfo().then(res => {
                if (res.data.code === 1) {
                    this.sgInfo = res.data.data;
                }else {
                    this.$message.error("请求出错");
                }
            })
        },
        getPtInfo(){
            ptInfo().then(res => {
                if (res.data.code === 1) {
                    this.ptInfo = res.data.data;
                }else {
                    this.$message.error("请求出错");
                }
            })
        },
        getOrgList(){
            listOrg().then(res => {
                if (res.data.code === 1) {
                    this.orgList = res.data.data;
                }else {
                    this.$message.error("请求出错");
                }
            })
        },
        submitAnalyseForm(){
            this.$refs["analyseForm"].validate(valid => {
                if (valid) {
                    createAnalyseOrg(this.analyseForm).then(res => {
                        if (res.data.code === 1) {
                            this.isOrgAnalyseShow = false;
                            this.getPageList();
                            this.getResourceInfo();
                            this.getPtInfo();
                        }else {
                            this.$message.error(res.data.msg);
                        }
                    })
                }
            })
        },
        getPageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageAnalyseOrg(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            })
        },
        handleOpen(){
            this.analyseForm.orgId = '';
            this.analyseForm.totalCount = 1;
            this.analyseForm.resourceType = 0;
            this.isOrgAnalyseShow = true;
        },
        handleQuery(){
            this.getPageList();
        },
        handleDetail(row){
            this.$router.push({
                path: "/analyseDetail",
                query: {
                    signId: row.orgId,
                }
            });
        },
        handleRecharge(row){
            this.rechargeForm.orgId = row.orgId;
            this.rechargeForm.orgName = row.orgName;
            this.rechargeForm.resourceType = row.resourceType;
            this.rechargeForm.rechargeCount = 1;
            this.rechargeType= row.resourceType;
            this.isOrgRechargeShow = true;
        },
        submitRechargeForm(){
            this.$refs["rechargeForm"].validate(valid => {
                if (valid) {
                    rechargeResource(this.rechargeForm).then(res => {
                        if (res.data.code === 1) {
                            this.isOrgRechargeShow = false;
                            this.getPageList();
                            this.getResourceInfo();
                            this.getPtInfo();
                        }else {
                            this.$message.error(res.data.msg);
                        }
                    })
                }
            })
        }
    }
};
</script>
<style scoped>
.stat-scrollbar{
    height: calc(100vh - 90px);
    width: 100%;
    padding: 10px 0 10px 20px;
    background-color: #fff;
    overflow-x: hidden!important;
    box-sizing: border-box;

}
.top-title{
    width: 100%;
    height: 50px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
}
.first-item{
    //margin-left: 10px;
}
.stat-title{
    height: 30px;
    line-height: 30px;
    color: #383838;
    text-align: left;
    font-size: 15px;
    font-family: sans-serif;
}
.stat-count{
    height: 40px;
    line-height: 40px;
    color: #383838;
    text-align: left;
    font-size: 15px;
    font-family: sans-serif;
}
.stat-count1{
    height: 20px;
    line-height: 20px;
    color: #383838;
    text-align: left;
    font-size: 15px;
    font-family: sans-serif;
}
.stat-count2{
    height: 20px;
    line-height: 20px;
    color: #383838;
    text-align: left;
    font-size: 14px;
    font-family: sans-serif;
}
.stat-count-span{
    color: #121212;
    cursor: pointer;
    font-weight: bold;
    font-family: sans-serif;
    font-size: 16px;
}
.form-box{
    padding-top: 20px;
}

.ar-dialog /deep/ .el-dialog__title {
    font-weight: bold!important;
    font-family: sans-serif!important;
    font-size: 16px!important;
    color: #121212!important;
}
.ar-form /deep/ .el-form-item{
    margin-bottom: 10px!important;
}
.ar-form /deep/ .el-form-item__label{
    color:#121212!important;
    font-weight:bold;
    font-size:15px
}
.s-zc{
    font-family: sans-serif;
    font-size: 13px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #67c23a;
    margin: auto;
}
.s-yj{
    font-family: sans-serif;
    font-size: 13px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #e6a23c;
    margin: auto;
}
.s-yw{
    font-family: sans-serif;
    font-size: 13px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #bd3124;
    margin: auto;
}

.s-zs{
    font-family: sans-serif;
    font-size: 13px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #67c23a;
    margin: auto;
}
.s-sy{
    font-family: sans-serif;
    font-size: 13px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #f56c6c;
    margin: auto;
}

</style>
